import * as React from 'react'
import { FormEvent, FunctionComponent } from 'react'
import { Dropdown, IDropdownProps } from '@fluentui/react'
import { DropdownOption } from '../../Dropdown/BaseDropdown'
import { FormikContextType } from 'formik'
import { getFieldNameValue, onMultiSelectDropdownChange } from '../../../helpers/formHelper'

type Props = IDropdownProps & {
    context: FormikContextType<any>
    fieldName: string
}

const FormikDropdown: FunctionComponent<Props> = props => {
    const { values, errors, setFieldValue, handleBlur } = props.context
    const value = getFieldNameValue(values, props.fieldName)

    return (
        <Dropdown
            onChange={(_: FormEvent<HTMLElement>, option?: DropdownOption) => {
                setFieldValue(props.fieldName, props.multiSelect ? onMultiSelectDropdownChange(option, value) : (option?.key ?? null))
            }}
            onBlur={handleBlur(props.fieldName)}
            selectedKey={props.multiSelect ? undefined : value}
            selectedKeys={props.multiSelect ? value : undefined}
            errorMessage={errors[props.fieldName] as string}
            {...props}
        />
    )
}

// noinspection JSUnusedGlobalSymbols
export default FormikDropdown
